import {Component, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ModalDismissReasons, NgbDropdownModule, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserIdleService} from 'angular-user-idle';
import {LoginService, ModuleService} from '@app/shared/services';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
// import {environment} from '@env/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  imports: [
    TranslatePipe,
    RouterLink,
    CommonModule,
    FormsModule,
    NgbDropdownModule,
  ],
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public error_message = "";
  public pushRightClass = '';
  public userCredentials = JSON.parse(localStorage.getItem('user') || "{}");
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public user_id = this.userCredentials.user_id;
  public current_password = '';
  public new_password = '';
  public confirm_password = '';
  closeResult = '';
  public logo = "";

  constructor(private modalService: NgbModal, private translate: TranslateService, public router: Router, public moduleService: ModuleService, public loginService: LoginService, private userIdle: UserIdleService) {
    this.translate.addLangs(['en', 'fr', 'ur', 'es', 'it', 'fa', 'de', 'zh-CHS']);
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();
    if (browserLang != null) {
      this.translate.use(browserLang?.match(/en|fr|ur|es|it|fa|de|zh-CHS/) ? browserLang : 'en');
    }

    this.router.events.subscribe(val => {
      if (
        val instanceof NavigationEnd &&
        window.innerWidth <= 992 &&
        this.isToggled()
      ) {
        this.toggleSidebar();
      }
    });
  }

  ngOnInit() {
    this.pushRightClass = 'push-right';
    this.getLogo();
  }

  isToggled(): boolean {
    const dom: HTMLBodyElement | null = document.querySelector('body');
    return dom?.classList.contains(this.pushRightClass) as boolean;
  }

  toggleSidebar() {
    const dom: any = document.querySelector('body');
    dom.classList.toggle(this.pushRightClass);
  }

  onLoggedout() {
    localStorage.removeItem('isLoggedin');
    localStorage.removeItem('activeTime');
    localStorage.removeItem('user');
    localStorage.removeItem('modules');
    localStorage.removeItem('sub_modules');
    localStorage.removeItem('access_types');
    localStorage.removeItem('user_rights');
  }

  changePassword() {
    const sentData = {
      user_id: this.user_id,
      current_password: this.current_password,
      new_password: this.new_password,
      confirm_password: this.confirm_password
    };
    this.moduleService.changePassword(sentData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.onLoggedin();
      }
    });
  }

  getAccessTypes() {
    this.loginService.getAccessTypes().subscribe((data: any) => {
      if (data['status'] == 'Success') {
        if (data['user_access_types']["status"] == 'Success') {
          localStorage.setItem('access_types', JSON.stringify(data['user_access_types']['data']));
        }
      }

    });
  }

  onLoggedin() {
    const login_data = {
      log_user: this.userCredentials.user,
      log_pass: this.new_password
    };
    this.loginService.checkCredentials(login_data).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        localStorage.setItem('isLoggedin', 'true');
        const date = new Date();
        localStorage.setItem('activeTime', date.toString());
        localStorage.setItem('user', JSON.stringify(result["data"]));
        this.getAccessTypes();
        this.userIdle.startWatching();
        this.userIdle.onTimerStart().subscribe(count => console.log(count));
        this.userIdle.ping$.subscribe(() => {

          const date = new Date();

          localStorage.setItem('activeTime', date.toString());
        });
        this.userIdle.onTimeout().subscribe(() => {
          localStorage.removeItem('activeTime');
          localStorage.removeItem('isLoggedin');
          localStorage.removeItem('user');
          localStorage.removeItem('modules');
          localStorage.removeItem('sub_modules');
          localStorage.removeItem('access_types');
          localStorage.removeItem('user_rights');
        });

        const path: string = result["data"]["redirect_page"].toString();
        this.loadModules(path);

      } else {
        this.error_message = result["message"];
        setTimeout(() => {

          this.error_message = "";

        }, 4000);
      }
    });
  }

  public loadModules(path: string) {
    const userCredentials = JSON.parse(localStorage.getItem('user') || "{}");
    const sentData = {
      user_group: userCredentials.user_login
    };
    this.moduleService.getModules(sentData).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        localStorage.setItem('modules', JSON.stringify(result["data"]));
        this.router.navigate([path]).then();
      }
    });
  }

  protected open(content: any) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public getLogo(){
    this.moduleService.getLogo().subscribe((result: any) => {
      const fullpath = result['logo_url'];
      this.logo = fullpath;
    });
  }
}
